import { cn } from "@theprelude/core";

export const Unavailable: React.FC = () => {
  return <div className="text-secondary-foreground">Unavailable</div>;
};

export const None: React.FC = () => {
  return <div className="text-shingle-grey">None</div>;
};

export const NotApplicable: React.FC<{
  className?: string;
}> = ({ className }) => {
  return <div className={cn("text-secondary-foreground", className)}>N/A</div>;
};
